module.exports = __webpack_public_path__ + "img/bgfw1.934a5647.png";